<template>
  <div class="toast" v-if="show">
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      default: '网络异常，请稍候重试',
      type: String
    },
  },
  data: () => {
    return {
      show: false,
    };
  }
};
</script>

<style lang="stylus" scoped>
.toast {
  z-index: 10000;
  position: fixed;
  display: table;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-left: 10px;
  padding-right: 10px;
}
.text{
  background: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  color: #fff;
  line-height: 1.8;
  border-radius: 4px;
  padding: 10px 20px;
}
</style>
